export default __webpack_public_path__ + "static/media/revievs3.130ed910.jpg";